import React from "react";
import { css } from "emotion";
import FavoriteIcon from "@material-ui/icons/Favorite";

import styleConfig from "styles/styleConfig";

const { colors, margin, padding, fontSize, gradient, screens } = styleConfig;

const footerStyle = css`
  display: flex;
  justify-content: center;
  padding: ${padding[4]} 0;
  background: ${gradient.primary};
  color: ${colors.gray[200]};
  font-size: ${fontSize.xs};
  span {
    svg {
      margin-bottom: -2px;
      font-size: ${fontSize.xs};
      fill: ${colors.secondary[500]};
    }
    &:first-child {
      margin-right: ${margin[1]};
    }
    &:last-child {
      margin-left: ${margin[1]};
    }
  }
  a {
    color: ${colors.gray[200]};
    transition: all 0.3s ease;
    &:hover {
      color: ${colors.gray[300]};
    }
  }
  @media (max-width: ${screens.MOBILE_WIDTH}px) {
    flex-direction: column;
    text-align: center;
    .line {
      display: none;
    }
  }
`;

const FooterSmall: React.FC = () => {
  return (
    <div className={footerStyle}>
      <span>&copy; Copyright {new Date().getFullYear()}, Erba Supermarkt</span>
      <span className="line">|</span>
      <span>
        Made with <FavoriteIcon /> by{" "}
        <a href="https://ismailkutlu.github.io/" target="_blank" rel="noopener noreferrer">
          ismailkutlu
        </a>
      </span>
    </div>
  );
};

export default FooterSmall;
